import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { HttpClient } from '@angular/common/http';

import { Map as MapboxMap, LngLatBounds } from 'mapbox-gl';
import * as mapboxgl from 'mapbox-gl';

// Envioronment
import { environment } from "../../../../environments/environment";

// Services
import { ExternalService } from 'src/app/Services/external.service';
import { ApiService } from 'src/app/Services/api.service';
import { CmsService } from 'src/app/Services/cms.service';
import { UtilsService } from 'src/app/Services/utils.service';

declare let gtag: Function; // For GA4

interface MarkerStyle {
  src: string;
  width: string;
  height: string;
  offset: [number, number];
  zIndex: number;
}

@Component({
    selector: 'app-linhas',
    templateUrl: './linhas.component.html',
    standalone: false
})
export class LinhasComponent implements OnInit {
  map!: MapboxMap;
  mapVisible: boolean = false;

  municipalities: any[] = [];

  home_content: string = 'linhas-home-page';
  homeInfo: any = {};

  // Map Style && Options
  zoom = environment.mapZoom;
  center_orig: google.maps.LatLngLiteral = {
    lat: environment.mapCenter.lat,
    lng: environment.mapCenter.lon,
  };
  center: google.maps.LatLngLiteral = {
    lat: environment.mapCenter.lat,
    lng: environment.mapCenter.lon,
  };

  public markerStyleSelected: MarkerStyle = {
    src: 'assets/img/map/1x/stop-icn-selected2.png',
    width: '47px',
    height: '80px',
    offset: [23, 0],
    zIndex: 1
  };

  private markerStyleStart: MarkerStyle = {
    src: 'assets/img/map/1x/start-route.png',
    width: '32px',
    height: '41px',
    offset: [0, 0],
    zIndex: 1
  };

  private markerStyleEnd: MarkerStyle = {
    src: 'assets/img/map/1x/end-route.png',
    width: '32px',
    height: '41px',
    offset: [0, 0],
    zIndex: 1
  };

  // End Map Style && Options

  // DatePicker ngx-bootstrap
  bsValue = new Date();
  bsConfig: Partial<BsDatepickerConfig> = {};
  minDate  = new Date();
  maxDate = new Date();

  stops: any[] = []

  selectedStop: any = '';

  routes: any[] = []

  selectedRoute: any = {
    'number': '',
    'name': ''
  }

  routeColor: string = '';
  routeId: string = '';

  route: any[] = []

  timesTrips: any[] = [];
  scheduleStops: any[] = [];
  firstScheduleStop: any;
  lastScheduleStop: any;
  availableTrips: any[] = [];
  hasTrips: boolean = false;
  hasTimes: boolean = false;

  lineReady: boolean = false;

  searchForm: FormGroup = new FormGroup({
    municipality: new FormControl(''),
    line: new FormControl(''),
    direction: new FormControl(''),
    date: new FormControl('')
  });

  searchProcess: boolean = false;
  searching: boolean = false;
  searchingTimetable: boolean = false;

  tripForm: FormGroup = new FormGroup({
    start: new FormControl('')
  });

  scheduleArray: { hour: string, minutes: string[] }[] = [];

  noTimetable: boolean = false;

  // ---CMS---
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  timetables_content: string = 'linhas-horario';
  timetablesInfo: any = {};

  // ---Mapbox---
  routeGeoJson: GeoJSON.Feature<GeoJSON.LineString> | undefined;
  currentRouteColor: string = '#FF0000'
  arrowIconReady = false;
  bounds: LngLatBounds | undefined;

  currentStyle: string = 'streets';
  mapStyle: string = 'mapbox://styles/mapbox/streets-v12';

  warnings_content_name: string = 'linhas-avisos-alertas';
  warningsReady: number = 0;
  warningsList: any[] = [];
  warningsListShow: any[] = [];
  warningsListSize: number = 0;

  constructor(
    private externalService: ExternalService,
    private utilsService: UtilsService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private router: Router,
    private cmsService: CmsService,
    private translate: TranslateService,
    private title: Title,
    private http: HttpClient
) {
    this.setDateRange();
    this.configureDatepicker();
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['linhas']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit() {
    this.getMunicipalities();
    this.getTimetablesContent();
    this.getWarnings();
  }


  getTimetablesContent(){
    this.cmsService.getContentList(this.timetables_content, this.language).subscribe(
      {
        next: data => {
          this.timetablesInfo = data['body']['data'];

          this.getWarningsContent();
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getWarningsContent(){
    this.cmsService.getContentList(this.home_content, this.language).subscribe(
      {
        next: data => {
          this.homeInfo = data['body']['data']

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  setDateRange(): void {
    const today = new Date();
    this.minDate.setDate(today.getDate());
    this.maxDate.setDate(today.getDate() + 30);
    this.searchForm = this.formBuilder.group(
      {
        municipality: [''],
        line: [''],
        direction: [''],
        date: [today]
      },
    );

    this.tripForm = this.formBuilder.group(
      {
        start: ['']
      },
    );

    this.onChanges()
  }

  isFormValid(): boolean {
    const municipalityControl = this.searchForm.get('municipality');
    const lineControl = this.searchForm.get('line');
    const directionControl = this.searchForm.get('direction');
    return !!municipalityControl?.value && !!lineControl?.value && !!directionControl?.value;
  }

  isFormAnyField(): boolean {
    const municipalityControl = this.searchForm.get('municipality');
    const lineControl = this.searchForm.get('line');
    const directionControl = this.searchForm.get('direction');
    return !!municipalityControl?.value || !!lineControl?.value || !!directionControl?.value;
  }

  onReset(): void {
    const today = new Date();
    this.searchForm.get('municipality')?.setValue('');
    this.searchForm.get('direction')?.setValue('');
    this.searchForm.get('date')?.setValue(today);
    const routeListOptions = document.getElementById("routeListOptions") as HTMLDataListElement;
    routeListOptions.innerHTML = "";
    const routeList = document.getElementById("routeList") as HTMLInputElement;
    routeList.value = '';
  }

  onChanges(){
    this.searchForm.get('municipality')?.valueChanges.subscribe(
      val => {
        if (val != '') {
          this.searchForm.get('line')?.setValue('')
          this.listRoutesByMunicipality(val);
        } else {
          this.routes.splice(0)
        }

      }
    )
  }

  configureDatepicker(): void {
    this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      showWeekNumbers: false,
      isAnimated: true,
      minDate: this.minDate,
      maxDate: this.maxDate,
      dateCustomClasses: this.generateCustomClasses()
    };
  }

  generateCustomClasses(): Array<{ date: Date; classes: string[] }> {
    const customClasses: Array<{ date: Date; classes: string[] }> = [];
    const today = new Date();
    for (let i = 2; i <= 30; i++) {
      const customDate = new Date(today);
      customDate.setDate(today.getDate() + i);
      customClasses.push({
        date: customDate,
        classes: ['dateBold']
      });
    }
    return customClasses;
  }

  listRoutesByMunicipality(municipality: string){
    this.externalService.getRoutesByMunicipality(municipality).subscribe(
      {
        next: data => {
          this.routes.splice(0);
          const routeListOptions = document.getElementById("routeListOptions") as HTMLDataListElement;
          routeListOptions.innerHTML = "";

          data.forEach(item => {
            let route = {
              number: item['pCodCarOperador'],
              name: item['pDesignacao'],
              municipality: municipality,
              operator: item['pdesigOperador'],
              codeCIM: item['pCodCarCIM'],
              color: item['pColorHex'],
              display: `${item['pCodCarOperador']} - ${item['pDesignacao']}`
            }
            const opt = document.createElement("option");
            opt.value = route.number + ' - ' + route.name;

            this.routes.push(route);
            routeListOptions.appendChild(opt)
          });
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  getRouteDetail(routeId: string){
    let id = '1:' + routeId
    this.externalService.getRouteDetail(id)
      .subscribe({
        next: data => {
          this.filterWarnings((data as any)['shortName'], (data as any)['agency']['id'])
        }, 
        error: er => {
          console.error(er);
        }
      })
  }

  searchSchedules(){
    this.scheduleArray.splice(0)

    this.selectedStop = undefined;

    this.searchProcess = true;
    this.searching = true;
    this.routeColor = ''

    if (this.routes.length > 0) {
      let rte = this.searchForm.get('line')?.value.split(' - ')[0]
      this.selectedRoute = this.routes.filter(route => route.number == rte)[0]
      this.routeColor = this.selectedRoute['color']

      const fullUrl = window.location.href; 
      const pagePath = window.location.pathname;

      gtag('event', 'select_route', {
        'route_name': this.selectedRoute['display'], 
        'municipality': this.selectedRoute['municipality'],
        'page_path': pagePath,
        'full_url': fullUrl,
        'subdomain': 'website'
      });

      this.getRouteDetail(this.selectedRoute['codeCIM']);
    }


    let date = this.utilsService.getDateForSearch(this.searchForm.get('date')?.value);

    this.routeId = this.selectedRoute['codeCIM'];

    let postData = {
      route_id: this.routeId,
      direction: this.searchForm.get('direction')?.value,
      date: date
    }

    this.hasTimes = false;
    this.hasTrips = false;

    //this.searching = false;
    //this.searchingTimetable = false;
    //this.hasTimes = true;
    this.getTimetable(postData)
  }

  getMunicipalities(){
    this.externalService.getMunicipalities().subscribe(
      {
        next: data => {

          this.municipalities.splice(0)

          data.forEach(element => {
            let mun = {
              name: element['pDescricao'],
              code: element['pDescricao'],
              key: element['pKey'],
              region: element['pNUTIII']
            }

            this.municipalities.push(mun)
          });

          this.municipalities = this.municipalities.sort((a: any, b: any) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }) );

          this.getStops()
        },
        error: er => {
        this.router.navigate(['/500']);
        }
      })
  }

  getStops(){
    this.externalService.getStops().subscribe(
      {
        next: data => {

          this.stops.splice(0)

          data.forEach(item => {
              let stop = {
                id: item['stop_id'],
                code: item['stop_id'],
                name: item['stop_name'],
                municipality: '',
                lat: item['lat'],
                lng: item['lon'],
                zone: item['zone_id']
              }

              this.stops.push(stop);
          });

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  calculateCenter(points: any[]) {
    if(points.length > 0){
      const latitudes = points.map(point => point.lat);
      const longitudes = points.map(point => point.lng);

      const avgLat = latitudes.reduce((acc, lat) => acc + lat, 0) / latitudes.length;
      const avgLng = longitudes.reduce((acc, lng) => acc + lng, 0) / longitudes.length;

      return { lat: avgLat, lng: avgLng };
    } else {
      return { lat: this.center_orig.lat, lng: this.center_orig.lng };
    }
  }

  getShapes(params: {}) {
    this.lineReady = false;
    this.apiService.getShapes(params).subscribe({
      next: data => {
        const rawCoordinates = data['body']['features'][0]['geometry']['coordinates'];

        this.routeGeoJson = {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: rawCoordinates
          }
        };

      const bounds = new LngLatBounds();

        rawCoordinates.forEach((coord: [number, number]) => {
          bounds.extend(coord);
        });
        this.bounds = bounds;

        this.currentRouteColor = this.routeColor;

        this.lineReady = true;

        this.map.fitBounds(bounds, { padding: 50 });
      },
      error: er => { console.error(er); }
    });
  }

  resetShape() {
    this.routeGeoJson = undefined;
  }

  getTimetable(params: {}){
    this.searchingTimetable = true;
    this.noTimetable = false;

    this.mapVisible = true;

    this.apiService.getTimetable(params).subscribe({
      next: data => {

        let result = data['body'];

        let stop_sequence_order = data['body']['stop_sequence_order']

        if (result['available_trips'] != undefined) {

          this.tripForm.get('start')?.setValue('');
          this.hasTrips = true;

          this.availableTrips = result['available_trips']

          let trip = this.availableTrips.filter(
            trip => trip['is_current_time'] == true
          )

          this.tripForm.get('start')?.setValue(trip[0]['trip_id'])

          this.tripForm.get('start')!.valueChanges.subscribe(
            val => {
              let params = {
                route_id: this.routeId,
                trip_id: val,
                direction: this.searchForm.get('direction')!.value,
                date: this.utilsService.getDateForSearch(this.searchForm.get('date')?.value)

              }
              if(!this.searchProcess){
                this.selectedStop = undefined
                this.getTimetable(params);
              }
            }
          )

          this.searchProcess = false;

          let params = {
            route_id: this.routeId,
            trip_id: trip[0]['trip_id'],
            direction: this.searchForm.get('direction')!.value,
            date: this.utilsService.getDateForSearch(this.searchForm.get('date')?.value)
          }

          this.getTimetable(params);
        }

        if (result['times'] != undefined){

          let shapePostData = {
            route_id: this.searchForm.get('line')?.value.split(' - ')[0],
            direction_id: this.searchForm.get('direction')?.value
          }

          if (result['trip_ids'] != undefined && result['trip_ids'].length > 0){
            (shapePostData as any)['trip_id'] = result['trip_ids'][0]
          }

          if ((params as any)['trip_id'] != undefined) {
            (shapePostData as any)['trip_id'] = (params as any)['trip_id']
          }

          this.getShapes(shapePostData)

          this.hasTimes = true;

          this.timesTrips = result['times'];

          let i = 0;

          this.scheduleStops.splice(0);

          stop_sequence_order.forEach((key: any, index: any) => {

            let stop = this.stops.find(o => o.id === key);

            if(index == 0 && stop != undefined){
              this.center = { lat: stop.lat, lng: stop.lng}
            }

            if(stop){
              const transformed = this.timesTrips[key].reduce((acc: any, time: any) => {
                const [hour, minute, second] = time.split(':');

                if (!acc[hour]) {
                    acc[hour] = new Set();
                }
                acc[hour].add(minute);

                return acc;
              }, {} as Record<string, Set<string>>);

              // Convert Sets to arrays for the final result
              const result = Object.fromEntries(
                  Object.entries(transformed).map(([hour, minutesSet]) => [
                      hour,
                      Array.from(minutesSet as Set<string>),
                  ])
              );

              let stopToAdd = {
                id: stop['id'],
                code: stop['code'],
                name: stop['name'],
                lat: stop['lat'],
                lng: stop['lng'],
                schedule: result,
                zone: stop['zone']
              }

              this.scheduleStops.push(stopToAdd)
            }

            i++

          })

          this.firstScheduleStop = this.scheduleStops[0];
          this.lastScheduleStop = this.scheduleStops[this.scheduleStops.length -1];

          const routeMap = document.getElementById('routeMap');
          if (routeMap) {
            routeMap.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          this.searching = false;
          this.searchingTimetable = false;
          setTimeout(() => {
            this.map.resize();
          }, 0)
        }

      },
      error: er => {
        this.noTimetable = true;
        this.searching = false;
        this.searchingTimetable = false;
        setTimeout(() => {
          this.map.resize();
        }, 0)
      }
    })
  }

  selectStop(stop: any, fromMap: boolean){

    this.selectedStop = stop;

    if (this.selectedStop && this.map) {
      this.map.flyTo({
        center: [Number(this.selectedStop.lng), Number(this.selectedStop.lat)],
        zoom: 15,
        speed: 1.5,
        curve: 1
      });
    }

    this.scheduleArray = Object.keys(this.selectedStop.schedule).map(hour => ({
      hour,
      minutes: this.selectedStop.schedule[hour]
    }));

    this.scheduleArray.sort((a,b) => (a.hour > b.hour) ? 1 : -1 )

    if(fromMap){
      this.scrollToStop(this.selectedStop.id)
    }
  }

  scrollToStop(id: string): void {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  getHours(stop_schedule: any): string[] {
    let response = Object.keys(stop_schedule).sort((a,b) => (a > b ) ? 1 : -1 );
    return response;
  }

  hasMinutes(hour: string, stop_schedule: any): boolean {
    return stop_schedule[hour] && stop_schedule[hour].length > 0;
  }

  /* Mapbox Methods */

  onMapLoad(map: MapboxMap) {
    this.map = map;

    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
      showZoom: true,
      visualizePitch: false
    });
    this.map.addControl(nav, 'bottom-right');

    const geolocate = new mapboxgl.GeolocateControl({
      positionOptions: { enableHighAccuracy: true },
      trackUserLocation: true
    });
    this.map.addControl(geolocate, 'bottom-right');

    this.map.flyTo({
      center: [Number(this.center.lng), Number(this.center.lat)],
      zoom: 8,
      speed: 12,
      curve: 1
    });

    //console.log('💸 NEW BILLING SESSION STARTED 💸');
    const svgString = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="25" height="25">
        <g transform="rotate(90, 6, 6)">
          <path d="M10.1,4.5L5.9.3h0c-.4-.4-1-.4-1.4,0L.3,4.5c-.4.4-.4,1,0,1.4s1,.4,1.4,0l3.5-3.5,3.5,3.5c.2.2.4.3.7.3h0c.3,0,.5-.1.7-.3.4-.4.4-1,0-1.4Z"
                fill="#ffffff"
                stroke="#000000"
                stroke-width="1"/>
        </g>
      </svg>
    `;

    const arrowUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString);

    const img = new Image(25, 25);

    img.onload = () => {
      if (!map.hasImage('arrow-icon')) {
        map.addImage('arrow-icon', img);
        this.arrowIconReady = true;
      }
    };

    img.src = arrowUrl;
  }

  get pointsGeoJson(): GeoJSON.FeatureCollection {
    return {
      type: 'FeatureCollection',
      features: this.scheduleStops.map(stop => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [Number(stop.lng), Number(stop.lat)]
        },
        properties: {
          id: stop.id,
          name: stop.name,
        }
      }))
    };
  }

  cursorStyle = '';

  onPointClick(event: any) {
    const properties = event.features[0].properties;

    let selStop = this.scheduleStops.find((stopInfo) => stopInfo['id'] == properties.id);

    this.selectStop(selStop, true);
  }

  onZoomChanged() {
    if (!this.map) return;

    const zoom = this.map.getZoom();

    if (zoom !== undefined && zoom !== null) {
      this.zoom = zoom;
    }
  }

  getMarkerStyle(type: string): MarkerStyle {

    let markerStyle = type == 'start'
      ? this.markerStyleStart
      : this.markerStyleEnd;

    return markerStyle;
  }

  changeStyle(layer: 'streets' | 'satellite') {
    this.currentStyle = layer;

    if (layer === 'streets') {
      this.mapStyle = 'mapbox://styles/mapbox/streets-v12';
    } else {
      // Satellite with Streets (Hybrid)
      this.mapStyle = 'mapbox://styles/mapbox/satellite-streets-v12';
    }
  }

  getWarnings(){
    this.warningsReady = 0;
    this.warningsList = [];
    this.cmsService.getContentList(this.warnings_content_name, this.language).subscribe(
      {
        next: data => {

          let today = new Date()

          let list = data['body']['data'];

          let filteredList: any[] = []

          list.forEach((element: any) => {
            const startDate = new Date(element.Inicio);
            const endDate = new Date(element.Fim != null ? element.Fim : 4133894400000);
            endDate.setHours(23, 59, 59, 999);

            if(today >= startDate && today <= endDate){
              element.municipalities_string = element.Municipios.map((item: any) => item.Municipio).join(", "),
              filteredList.push(element)
            };

            let date = new Date(element.Inicio)
            element.formattedDate = Intl.DateTimeFormat(this.language, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);


          });

          filteredList.sort((a, b) => (a.Inicio > b.Inicio) ? -1 : 1 );

          this.warningsList = Object.values(
            filteredList.reduce((acc, item) => {
                  if (!acc[item.Inicio]) {
                      acc[item.Inicio] = { Inicio: item.Inicio, formattedDate: item.formattedDate, Avisos: [] };
                  }
                  acc[item.Inicio].Avisos.push(item);
                  return acc;
              }, {} as Record<string, { Inicio: string; formattedDate: string; Avisos: { Inicio: string; Titulo: string }[] }>)
          );

          this.warningsReady = 1;

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  filterWarnings(routeNumber: string, agencyId: string ){
    this.warningsListShow = this.warningsList
      .map(item => ({
        ...item,
        Avisos: item.Avisos.filter((warning: any) =>
          warning.Linhas?.includes(routeNumber) 
          || warning.Linhas?.toUpperCase().includes('TODAS')
          || warning.Linhas?.toUpperCase().includes('LOTE ' + agencyId))
      }))
      .filter(item => item.Avisos.length > 0)


    this.warningsListSize = this.warningsListShow.length;
  }

  getSchedulePdf(routeNumber: string){
    let fileUrl = environment.schedulesUrl + routeNumber + '.pdf';

    window.open(fileUrl, '_blank');
  }

  downloadPdf(routeNumber: string){
    let fileUrl = environment.schedulesUrl + routeNumber + '.pdf';

    this.http.get(fileUrl, { responseType: 'blob' }).subscribe((blob: any) => {
      // Create a link element
      const link = document.createElement('a');
      const commonUrl = window.URL.createObjectURL(blob);
      
      link.href = commonUrl;
      link.download =  routeNumber + '.pdf'; 
      link.click();

      const fullUrl = window.location.href; // Full URL
      const pagePath = window.location.pathname; // Path after domain

      gtag('event', 'file_download', {
        'file_name': routeNumber + '.pdf',
        'page_path': pagePath,
        'page_title': routeNumber + '.pdf',
        'full_url': fullUrl,
        'subdomain': 'website'
      });
      
      // Clean up
      window.URL.revokeObjectURL(commonUrl);
      link.remove();
  });
  }
}
